type WebGatewayEnv = {
  VUE_APP_WEB_GATEWAY_URL?: string
}

export function getWebGatewayUrl (env: WebGatewayEnv): string {
  let url = ''

  if (env.VUE_APP_WEB_GATEWAY_URL) {
    // shortcut: force web-gateway url from env.
    url = env.VUE_APP_WEB_GATEWAY_URL
  } else {
    url = window.location.origin.replace('://', '://web-gateway.')
  }

  return url.replace(/\/+$/, '') + '/index.html'
}
